import { getAuthenticatedUser, User } from '../AuthenticationService';
import { ConsentCategory } from '../ConsentService';

import { MessagingZendeskApi, ZendeskApiKeyError, ZendeskService } from './types';
import { hasZendeskApiInitialized } from './utils';

let initializationPromise: Promise<MessagingZendeskApi> | null = null;

async function initialize() {
  if (initializationPromise) {
    return initializationPromise;
  }

  initializationPromise = new Promise((resolve, reject) => {
    if (!environment.ZENDESK_MESSAGING_KEY) {
      reject(new ZendeskApiKeyError());
    }

    if (hasZendeskApiInitialized(window)) {
      resolve(window.zE as MessagingZendeskApi);
    }

    const script = document.createElement('script');

    script.setAttribute('type', 'text/javascript');
    script.setAttribute('id', 'ze-snippet');
    script.setAttribute('src', `https://static.zdassets.com/ekr/snippet.js?key=${environment.ZENDESK_MESSAGING_KEY}`);

    script.addEventListener('load', () => {
      if (hasZendeskApiInitialized(window)) {
        const zendesk = window.zE as MessagingZendeskApi;

        zendesk('messenger:set', 'locale', getAuthenticatedUser(User.Preferences).language.split('-')[0]);
        zendesk('messenger', 'hide');
        zendesk('messenger:on', 'close', () => {
          if (hasZendeskApiInitialized(window)) {
            const zendesk = window.zE as MessagingZendeskApi;

            zendesk('messenger', 'hide');
          }
        });

        resolve(zendesk);
      }
    });

    script.dataset.cookieconsent = ConsentCategory.Necessary;
    document.head.appendChild(script);
  });

  return initializationPromise;
}

const MessagingZendeskService: ZendeskService<MessagingZendeskApi> = {
  initialize,
  zendesk: (type, command, payload) => {
    if (hasZendeskApiInitialized(window)) {
      return (window.zE as MessagingZendeskApi)(type, command, payload);
    }
  },
};

export default MessagingZendeskService;
